/**
 * ui/screens/ForcePasswordChange — A4 : impose le changement du MDP par défaut.
 * @author Dr Hamid MADANI <drmdh@msn.com>
 *
 * Écran bloquant tant que `mustChangePassword` est vrai (fin de `admin/admin`).
 *
 * NOTE ARCHITECTURE (D15) : la CAPACITÉ « cycle de vie des identifiants »
 * (changement forcé, expiration, rotation) est une préoccupation d'AUTH →
 * candidate à `@mostajs/auth` (auth-stack). Cet écran est la face UI, candidat
 * à un module `auth-ui` ; il vit ici en attendant.
 */
import React, { useState } from 'react';
import { useAuth } from '../AuthProvider';
import { makeT } from '../../engine/i18n';

export default function ForcePasswordChange() {
  const { changePassword, logout } = useAuth();
  const t = makeT('fr');
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 6) { setError('Au moins 6 caractères.'); return; }
    setBusy(true);
    setError('');
    try {
      await changePassword(current, next);
    } catch (err) {
      setError(err?.response?.status === 401 ? 'Mot de passe actuel incorrect' : String(err?.message || err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="centered">
      <form className="card" onSubmit={submit}>
        <h1>{t('app.title')}</h1>
        <h2 className="warn">{t('pwd.title')}</h2>
        <label>{t('pwd.current')}</label>
        <input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} autoFocus />
        <label>{t('pwd.new')}</label>
        <input type="password" value={next} onChange={(e) => setNext(e.target.value)} />
        {error && <p className="error">{error}</p>}
        <button type="submit" disabled={busy || !current || !next}>{t('pwd.submit')}</button>
        <button type="button" className="ghost" onClick={logout}>⎋</button>
      </form>
    </div>
  );
}
